<template>
  <div>
    <router-view :data="this.data"></router-view>
  </div>
</template>
<script type="text/ecmascript-6">
import { getEquipmentInfo } from '@/api/equipment'
import { getUrlParam } from '@/utils/utils'
export default {
  data() {
    return {
      data: {}
    }
  },
  created() {
    this._getEquipmentInfo()
  },
  methods: {
    _getEquipmentInfo() {
      this.$loading.open()
      let sn = getUrlParam('serial_no')
      getEquipmentInfo(sn).then(res => {
        this.data = res.data
        this.$loading.close()
      }).catch(err => {
        console.log(err)
        this.$loading.close()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/equipment/main.vue